import React, { useEffect, useState } from "react";
import Meta from "./../components/Meta";
import PageLoader from "./../components/PageLoader";
import FormAlert from "./../components/FormAlert";
import { requireAuth } from "./../util/auth";
import { redirectToCheckout } from "./../util/stripe";

function PaymentPage(props) {
  const [formAlert, setFormAlert] = useState();

  let totalCharge =
    (props.location.state.signupObject.division_cost +
      props.location.state.signupObject.side_games_cost) *
    100;
  let entryDescription = "Event Registration";
  let signupObject = props.location.state.signupObject;
  // Debug check to see what we have in payment page
  console.log("Payment page signupObject:", signupObject);

  // Show alert if event_id is still undefined at payment stage
  const eventId = signupObject.events_id || signupObject.event_id;
  if (!eventId) {
    alert("ERROR: event_id is undefined in payment page!");
  }

  useEffect(() => {
    redirectToCheckout(totalCharge, entryDescription, signupObject).catch(
      (error) => {
        console.log("error", error);
        setFormAlert({
          type: "error",
          message: error.message,
        });
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Meta title="Signup" />
      <PageLoader>
        {formAlert && (
          <FormAlert
            type={formAlert.type}
            message={formAlert.message}
            style={{ maxWidth: "500px" }}
          />
        )}
      </PageLoader>
    </>
  );
}

export default requireAuth(PaymentPage);
